(function (){
    'use strict';
    angular.module('app')
    .controller('CreateProfileController',CreateProfileController)
    CreateProfileController.$inject =[
        '$scope',
        '$rootScope',
        '$location',
        'AffiliateService',
        'toastr'
    ];

    function CreateProfileController ($scope,$rootScope,$location,AffiliateService,toastr){

        const vm = this;
        vm.paramsId = null;
        vm.marketingCompany ={};
        $scope.form={};
        vm.goBack = function(){ 
            $location.path('/affiliates-sales');
        }

        vm.onSubmit = function (form){
            if(form.$invalid){
                for(let field of $scope.form.$error.required){
                    if(field.$name){
                        $scope.form[field.$name].required = true
                    }
                }
               return;
            }
            save();
        }

        init();

        function init(){
            vm.role = $rootScope.GlobalProfile.permissionGroup.roles.find(permission => permission.code ==  'ROLE_COMPANY_ADMIN' ||  permission.code =='ROLE_ADMIN')
        }

        function save(){
            vm.marketingCompany.locationId = vm.location.id;
            vm.marketingCompany.companyId = $rootScope.GlobalProfile.company.id;
            vm.loading = true;
            AffiliateService.createPartnerCompany(
                res=>{
                    toastr.success('Successfully Save.');
                    vm.loading = false;
                    $location.path('/affiliates-sales');
                    
                },
                err =>{
                    toastr.error(err.message);
                    vm.loading = false;
                },
                vm.marketingCompany
            )
        }

    }
})()


// WEBPACK FOOTER //
// ./js/controllers/affiliate-sale/CreateProfileController.js